/* tslint:disable */
/* eslint-disable */
/**
 * Organization service API
 * Service for Organizations management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApprovedEmailInfo
 */
export interface ApprovedEmailInfo {
    /**
     * White listed and expected email
     * @type {string}
     * @memberof ApprovedEmailInfo
     */
    email: string;
    /**
     * Service provider id. One org can have several service provider roles
     * @type {string}
     * @memberof ApprovedEmailInfo
     */
    serviceProviderId: string;
}

/**
 * Check if a given object implements the ApprovedEmailInfo interface.
 */
export function instanceOfApprovedEmailInfo(value: object): boolean {
    if (!('email' in value)) return false;
    if (!('serviceProviderId' in value)) return false;
    return true;
}

export function ApprovedEmailInfoFromJSON(json: any): ApprovedEmailInfo {
    return ApprovedEmailInfoFromJSONTyped(json, false);
}

export function ApprovedEmailInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApprovedEmailInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'serviceProviderId': json['serviceProviderId'],
    };
}

export function ApprovedEmailInfoToJSON(value?: ApprovedEmailInfo | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
        'serviceProviderId': value['serviceProviderId'],
    };
}

